<template>
  <div
    :id="`category-${categoryId}`"
    :data-test-id="`category-${categoryIndex}`"
    :class="['menu-list__category', {
      'menu-list__category--favorites': isFavoriteCategory,
      'menu-list__category--specials': isSpecialCategory,
      'menu-list__category--open': isCategoryOpen
    }]"
  >
    <button
      class="menu-list__category-header"
      type="button"
      tabindex="-1"
      @click="handleMenuCategoryClick"
    >
      <div class="layout layout--icon">
        <span
          v-if="isSpecialCategory"
          class="icon icon--bigger fa-utensils-alt secondary"
        />

        <span
          v-if="isFavoriteCategory"
          class="icon icon--bigger far fa-heart secondary"
        />

        <h2 class="title title--3 secondary no-wrap-ellipsis">
          {{ category.displayName }}
        </h2>
      </div>

      <current-day-menu-schedule
        class="menu-list__category-header-content"
        :schedule="category.schedule"
      />

      <p
        v-if="category.description"
        class="menu-list__category-header-content"
      >
        {{ category.description }}
      </p>

      <p
        v-if="isReadOnly && category.modifierSummary"
        class="menu-list__category-header-content smaller"
      >
        {{ category.modifierSummary }}
      </p>
    </button>

    <div class="menu-list__items">
      <menu-list-item
        v-for="(item, menuItemIndex) in category.menuItems"
        :key="item.originalFavoriteItemId || item.menuItemId"
        :is-favorite="isFavoriteCategory"
        :item="item"
        :category-id="categoryId"
        :is-read-only="isReadOnly"
        :data-test-id="`menu-item-${categoryIndex}-${menuItemIndex}`"
        @open-item="handleMenuItemClick(item)"
      />
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import MenuListItem from './menu-list-item.vue';


  export default {
    name: 'MenuListCategory',

    components: {
      MenuListItem
    },

    props: {
      category: {
        type: Object,
        required: true
      },

      categoryIndex: {
        type: Number,
        required: true
      },

      openCategoryIds: {
        type: Array,
        required: true
      },

      isReadOnly: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapGetters('menu', ['menu']),

      categoryId() {
        return this.category.categoryId;
      },

      isCategoryOpen() {
        return this.openCategoryIds.includes(this.categoryId);
      },

      isSpecialCategory() {
        return this.category.categoryTemplate === 'SpecialsCategoryTemplate';
      },

      isFavoriteCategory() {
        return this.category.categoryTemplate === 'FavoritesCategoryTemplate';
      }
    },

    methods: {
      handleMenuCategoryClick() {
        this.$emit('open-menu-list-category', { categoryId: this.categoryId, doNotClose: false });
      },

      handleMenuItemClick(item) {
        this.$emit('open-menu-item', item);
      }
    }
  };
</script>
